/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API Listen
 * OpenAPI spec version: 1.0.0
 */
import { createInstance } from "./api-instance"
import type { BodyType } from "./api-instance"
export interface InfrastructureRes {
  isMaintenance: boolean
  requiredVersion: string
}

export type GuestAuthDtoClientType =
  (typeof GuestAuthDtoClientType)[keyof typeof GuestAuthDtoClientType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GuestAuthDtoClientType = {
  ANDROID: "ANDROID",
  IOS: "IOS",
  WEB: "WEB",
  EXTENSION: "EXTENSION",
} as const

export type GuestAuthDtoRegisteredDevice =
  (typeof GuestAuthDtoRegisteredDevice)[keyof typeof GuestAuthDtoRegisteredDevice]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GuestAuthDtoRegisteredDevice = {
  ANDROID: "ANDROID",
  IOS: "IOS",
  WEBSITE: "WEBSITE",
  EXTENSION: "EXTENSION",
} as const

export type GuestAuthDtoVoiceId =
  (typeof GuestAuthDtoVoiceId)[keyof typeof GuestAuthDtoVoiceId]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GuestAuthDtoVoiceId = {
  af_alloy: "af_alloy",
  af_aoede: "af_aoede",
  af_bella: "af_bella",
  af_kore: "af_kore",
  af_nicole: "af_nicole",
  af_nova: "af_nova",
  af_sarah: "af_sarah",
  am_echo: "am_echo",
  am_eric: "am_eric",
  am_fenrir: "am_fenrir",
  am_michael: "am_michael",
  am_onyx: "am_onyx",
  am_puck: "am_puck",
  bf_alice: "bf_alice",
  bf_emma: "bf_emma",
  bf_isabella: "bf_isabella",
  bm_fable: "bm_fable",
  bm_george: "bm_george",
  bm_lewis: "bm_lewis",
  ef_dora: "ef_dora",
  em_alex: "em_alex",
  em_santa: "em_santa",
  ff_siwis: "ff_siwis",
  if_sara: "if_sara",
  im_nicola: "im_nicola",
  pf_dora: "pf_dora",
  pm_alex: "pm_alex",
  pm_santa: "pm_santa",
} as const

export type GuestAuthDtoVoiceLang =
  (typeof GuestAuthDtoVoiceLang)[keyof typeof GuestAuthDtoVoiceLang]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GuestAuthDtoVoiceLang = {
  ENGLISH: "ENGLISH",
  SPANISH: "SPANISH",
  FRENCH: "FRENCH",
  ITALIAN: "ITALIAN",
  PORTUGUESE: "PORTUGUESE",
} as const

export interface GuestAuthDto {
  clientType?: GuestAuthDtoClientType
  deviceId?: string
  deviceName?: string
  appVersion?: string
  registeredDevice: GuestAuthDtoRegisteredDevice
  voiceId?: GuestAuthDtoVoiceId
  voiceLang?: GuestAuthDtoVoiceLang
}

export interface AccessTokenResponse {
  access_token: string
  refresh_token?: string
  expires_in?: number
  session_id?: string
}

export interface GuestUpgradeDto {
  email: string
  password: string
}

export interface PendingGuestUpgradeDto {
  /** @nullable */
  pendingEmail: string | null
}

export interface EmailConfirmDtoReq {
  code: string
}

export type SignUpDtoReqClientType =
  (typeof SignUpDtoReqClientType)[keyof typeof SignUpDtoReqClientType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignUpDtoReqClientType = {
  ANDROID: "ANDROID",
  IOS: "IOS",
  WEB: "WEB",
  EXTENSION: "EXTENSION",
} as const

export type SignUpDtoReqRegisteredDevice =
  (typeof SignUpDtoReqRegisteredDevice)[keyof typeof SignUpDtoReqRegisteredDevice]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignUpDtoReqRegisteredDevice = {
  ANDROID: "ANDROID",
  IOS: "IOS",
  WEBSITE: "WEBSITE",
  EXTENSION: "EXTENSION",
} as const

export interface SignUpDtoReq {
  clientType?: SignUpDtoReqClientType
  deviceId?: string
  deviceName?: string
  appVersion?: string
  email: string
  password: string
  registeredDevice: SignUpDtoReqRegisteredDevice
  voiceId: string
  voiceLang: string
}

export type AuthDtoReqClientType =
  (typeof AuthDtoReqClientType)[keyof typeof AuthDtoReqClientType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthDtoReqClientType = {
  ANDROID: "ANDROID",
  IOS: "IOS",
  WEB: "WEB",
  EXTENSION: "EXTENSION",
} as const

export interface AuthDtoReq {
  clientType?: AuthDtoReqClientType
  deviceId?: string
  deviceName?: string
  appVersion?: string
  email: string
  password: string
}

export interface RefreshSessionDto {
  refreshToken?: string
}

export interface SessionTokensDto {
  access_token: string
  refresh_token?: string
  expires_in: number
  session_id: string
}

export interface ExchangeExtensionCodeDto {
  code: string
  codeVerifier: string
  deviceId: string
  deviceName: string
  appVersion: string
}

export interface AuthorizeExtensionDto {
  redirectUri: string
  state: string
  codeChallenge: string
}

export interface AuthorizeExtensionResponseDto {
  redirectUrl: string
}

export type AuthSessionDtoClientType =
  (typeof AuthSessionDtoClientType)[keyof typeof AuthSessionDtoClientType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthSessionDtoClientType = {
  ANDROID: "ANDROID",
  IOS: "IOS",
  WEB: "WEB",
  EXTENSION: "EXTENSION",
} as const

export interface AuthSessionDto {
  id: string
  current: boolean
  clientType: AuthSessionDtoClientType
  /** @nullable */
  deviceName: string | null
  /** @nullable */
  platform: string | null
  /** @nullable */
  osName: string | null
  /** @nullable */
  osVersion: string | null
  /** @nullable */
  browser: string | null
  /** @nullable */
  appVersion: string | null
  /** @nullable */
  country: string | null
  createdAt: string
  lastUsedAt: string
  expiresAt: string
}

export interface RevokeSessionsResponseDto {
  revoked: number
}

export interface ResetPasswordDtoReq {
  email: string
}

export interface ValidateResetPasswordCodeRes {
  email: string
}

export interface ProcessResetPasswordDtoReq {
  code: string
  password: string
}

export interface UpdateEmailDtoReq {
  code: string
}

export interface UpdateEmailDtoRes {
  isRight: boolean
  access_token: string
}

export type SocialAuthDtoClientType =
  (typeof SocialAuthDtoClientType)[keyof typeof SocialAuthDtoClientType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocialAuthDtoClientType = {
  ANDROID: "ANDROID",
  IOS: "IOS",
  WEB: "WEB",
  EXTENSION: "EXTENSION",
} as const

export type SocialAuthDtoRegisteredDevice =
  (typeof SocialAuthDtoRegisteredDevice)[keyof typeof SocialAuthDtoRegisteredDevice]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocialAuthDtoRegisteredDevice = {
  ANDROID: "ANDROID",
  IOS: "IOS",
  WEBSITE: "WEBSITE",
  EXTENSION: "EXTENSION",
} as const

export interface SocialAuthDto {
  clientType?: SocialAuthDtoClientType
  deviceId?: string
  deviceName?: string
  appVersion?: string
  token: string
  registeredDevice: SocialAuthDtoRegisteredDevice
  voiceId: string
  voiceLang: string
}

export interface OuathAccessTokenResponse {
  access_token: string
  refresh_token?: string
  expires_in: number
  session_id: string
  is_registered_now: boolean
}

export interface ApplyPromoCodeDto {
  code: string
}

export interface StillHaveEmailNumbersRes {
  hasNumbers: boolean
  access_token: string
}

export interface ChangePasswordDtoReq {
  oldPass: string
  newPass: string
}

export interface NewTranslationDtoReq {
  key: string
  value: string
}

export type TranslationDictionaryDtoData = { [key: string]: string }

export interface TranslationDictionaryDto {
  version: number
  data: TranslationDictionaryDtoData
}

export interface TranslationVersionDto {
  version: number
}

export interface LangListItem {
  lang: string
  label: string
}

export interface ProvideCodeDtoReq {
  code: string
}

export interface ProvideCodeDtoRes {
  isRight: boolean
}

export interface ProvideNewEmailDtoReq {
  email: string
  code: string
}

export type GetMyOptionsDtoResVoice =
  (typeof GetMyOptionsDtoResVoice)[keyof typeof GetMyOptionsDtoResVoice]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMyOptionsDtoResVoice = {
  af_alloy: "af_alloy",
  af_aoede: "af_aoede",
  af_bella: "af_bella",
  af_kore: "af_kore",
  af_nicole: "af_nicole",
  af_nova: "af_nova",
  af_sarah: "af_sarah",
  am_echo: "am_echo",
  am_eric: "am_eric",
  am_fenrir: "am_fenrir",
  am_michael: "am_michael",
  am_onyx: "am_onyx",
  am_puck: "am_puck",
  bf_alice: "bf_alice",
  bf_emma: "bf_emma",
  bf_isabella: "bf_isabella",
  bm_fable: "bm_fable",
  bm_george: "bm_george",
  bm_lewis: "bm_lewis",
  ef_dora: "ef_dora",
  em_alex: "em_alex",
  em_santa: "em_santa",
  ff_siwis: "ff_siwis",
  if_sara: "if_sara",
  im_nicola: "im_nicola",
  pf_dora: "pf_dora",
  pm_alex: "pm_alex",
  pm_santa: "pm_santa",
} as const

export type GetMyOptionsDtoResPlan =
  (typeof GetMyOptionsDtoResPlan)[keyof typeof GetMyOptionsDtoResPlan]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMyOptionsDtoResPlan = {
  FREE: "FREE",
  PRO: "PRO",
} as const

export type GetMyOptionsDtoResVoiceLang =
  (typeof GetMyOptionsDtoResVoiceLang)[keyof typeof GetMyOptionsDtoResVoiceLang]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMyOptionsDtoResVoiceLang = {
  ENGLISH: "ENGLISH",
  SPANISH: "SPANISH",
  FRENCH: "FRENCH",
  ITALIAN: "ITALIAN",
  PORTUGUESE: "PORTUGUESE",
} as const

export interface GetMyOptionsDtoRes {
  voice: GetMyOptionsDtoResVoice
  voiceName: string
  availableSecondsToUse: number
  plan: GetMyOptionsDtoResPlan
  dailyAudioUsedSeconds: number
  dailyAudioLimitSeconds: number
  dailyAudioResetAt: string
  isReviewPopup: boolean
  voiceLang: GetMyOptionsDtoResVoiceLang
  needWebOnboarding: boolean
}

export interface SetMyOptionsDtoReq {
  voiceId: string
  voiceLang: string
  markWebOnboardingAsCompleted?: boolean
}

export interface LeaveFeedbackDtoReq {
  /** Feedback message */
  feedback: string
  /** Stars */
  stars: number
}

export type ContentItemCreationMode =
  (typeof ContentItemCreationMode)[keyof typeof ContentItemCreationMode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContentItemCreationMode = {
  FILE: "FILE",
  LINK: "LINK",
  TEXT: "TEXT",
  CAMERA: "CAMERA",
  SELECTION: "SELECTION",
} as const

export type ContentItemListenUntil = { [key: string]: unknown }

export type ContentItemViewMode =
  (typeof ContentItemViewMode)[keyof typeof ContentItemViewMode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContentItemViewMode = {
  PDF: "PDF",
  MARKDOWN: "MARKDOWN",
  TEXT: "TEXT",
} as const

export type ContentItemCreationStatus =
  (typeof ContentItemCreationStatus)[keyof typeof ContentItemCreationStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContentItemCreationStatus = {
  COMPLETED: "COMPLETED",
  PARTIALLY_COMPLETED_AND_STILL_PROCESSING:
    "PARTIALLY_COMPLETED_AND_STILL_PROCESSING",
} as const

export interface ContentItem {
  id: string
  title: string
  createdAt: string
  audioUrl: string
  isArchived: boolean
  creationMode: ContentItemCreationMode
  creattionFileExtension: string
  listenUntil: ContentItemListenUntil
  /** @nullable */
  sourceUrl: string | null
  /** @nullable */
  sourceTitle: string | null
  pdfUploaded: string
  audioTime: number
  combinedDataAbsoluteUrls: string[]
  viewMode: ContentItemViewMode
  markdownPageUrls: string[]
  isDefault: boolean
  creationStatus: ContentItemCreationStatus
}

export interface GetLibraryContentDtoMeta {
  totalItems: number
  totalPages: number
  currentPage: number
  itemsPerPage: number
}

export interface GetLibraryContentDtoRes {
  data: ContentItem[]
  meta: GetLibraryContentDtoMeta
}

export interface GetLibraryArchivedContentDtoRes {
  data: ContentItem[]
  meta: GetLibraryContentDtoMeta
}

export interface TempContentItem {
  id: string
  createdAt: string
  creationMode: string
  processInfo: string
}

export interface ContentUploadFileDto {
  filename: string
  contentType: string
  /**
   * @minimum 1
   * @maximum 524288000
   */
  size: number
}

/**
 * SelectionAnchor without `exact`
 */
export type SelectionMetaDtoSelector = { [key: string]: unknown }

export interface SelectionMetaDto {
  /** Snippet used as the title */
  title: string
  sourceUrl?: string
  sourceTitle?: string
  /** SelectionAnchor without `exact` */
  selector?: SelectionMetaDtoSelector
}

export type InitContentUploadDtoKind =
  (typeof InitContentUploadDtoKind)[keyof typeof InitContentUploadDtoKind]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InitContentUploadDtoKind = {
  FILE: "FILE",
  PHOTOS: "PHOTOS",
  TEXT: "TEXT",
} as const

export interface InitContentUploadDto {
  kind: InitContentUploadDtoKind
  files: ContentUploadFileDto[]
  selection?: SelectionMetaDto
}

export type ContentUploadTargetDtoHeaders = { [key: string]: unknown }

export interface ContentUploadTargetDto {
  index: number
  uploadUrl: string
  headers: ContentUploadTargetDtoHeaders
}

export interface InitContentUploadResponseDto {
  uploadId: string
  expiresAt: string
  uploads: ContentUploadTargetDto[]
}

export interface StartContentUploadDto {
  socketClientId?: string
}

export type StartContentCreationResponseDtoStatus =
  (typeof StartContentCreationResponseDtoStatus)[keyof typeof StartContentCreationResponseDtoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StartContentCreationResponseDtoStatus = {
  PROCESSING: "PROCESSING",
} as const

export interface StartContentCreationResponseDto {
  requestId: string
  status: StartContentCreationResponseDtoStatus
  /** Set for kind=TEXT: the Content row is created synchronously so the client can track it by id right away */
  contentId?: string
}

export interface CreateContentFromTextHttpDto {
  text: string
  socketClientId?: string
}

export interface ContentCreatedDto {
  createdId: string
  unableToScrap?: boolean
}

export interface ContentFromTextDto {
  text: string
}

export interface ContentFromUrlDto {
  url: string
}

export interface SetArchivedDto {
  id: string
  setArchived: boolean
}

export interface ChangeTitleDto {
  title: string
  id: string
}

export interface ContentIdDto {
  id: string
}

export interface RemoveTaskDto {
  tempContentId: string
}

export interface TaskAudioChunk {
  chunkIdx: number
  chunkAudioTime: number
  globalChunkAudioTime: number
  /** false while the chunk is playable but its word timestamps are still being generated */
  wordsReady: boolean
  /** Public URL of the chunk MP3 */
  url: string
}

export type GetManifestForProcessingContentDtoResCreationStatus =
  (typeof GetManifestForProcessingContentDtoResCreationStatus)[keyof typeof GetManifestForProcessingContentDtoResCreationStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetManifestForProcessingContentDtoResCreationStatus = {
  INITIALIZED: "INITIALIZED",
  PARTIALLY_COMPLETED_AND_STILL_PROCESSING:
    "PARTIALLY_COMPLETED_AND_STILL_PROCESSING",
  COMPLETED: "COMPLETED",
} as const

export interface GetManifestForProcessingContentDtoRes {
  totalAudioTime: number
  chunks: TaskAudioChunk[]
  taskId: string
  creationStatus: GetManifestForProcessingContentDtoResCreationStatus
  /** Final merged audio URL; empty string until COMPLETED */
  audioUrl: string
  /** @nullable */
  listenUntil: number | null
}

export interface TimedWordDto {
  /** @nullable */
  start_ts: number | null
  /** @nullable */
  end_ts: number | null
  text: string
  whitespace: string
  /** @nullable */
  char_start?: number | null
  /** @nullable */
  char_end?: number | null
  /** @nullable */
  chunkStartTs?: number | null
  /** @nullable */
  chunkEndTs?: number | null
}

export interface ChunkWordsDto {
  chunkIdx: number
  words?: TimedWordDto[]
  url?: string
  /** true when the chunk exists but its words are still being generated */
  pending?: boolean
}

/**
 * @nullable
 */
export type ContentSourceDtoSelector = { [key: string]: unknown } | null

export interface ContentSourceDto {
  contentId: string
  snippet: string
  text: string
  /** @nullable */
  selector: ContentSourceDtoSelector
  /** @nullable */
  sourceUrl: string | null
  /** @nullable */
  sourceTitle: string | null
}

export interface PdfActiveMetaDataWord {
  word: string
  start_ts: number
  end_ts: number
  chunkStartTs: number
  chunkEndTs: number
  chunkIdx: number
  pageIndex: number
  isAligned: boolean
  x: number
  y: number
  width: number
  height: number
}

export interface PdfActiveMetaDataPage {
  words: PdfActiveMetaDataWord[]
  pageIndex: number
}

export type PdfActiveMetaDataResponseViewMode =
  (typeof PdfActiveMetaDataResponseViewMode)[keyof typeof PdfActiveMetaDataResponseViewMode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PdfActiveMetaDataResponseViewMode = {
  PDF: "PDF",
} as const

export interface PdfActiveMetaDataResponse {
  viewMode: PdfActiveMetaDataResponseViewMode
  prevPageWords: PdfActiveMetaDataPage
  currentPageWords: PdfActiveMetaDataPage
  nextPageWords: PdfActiveMetaDataPage
}

export interface MarkdownActiveMetaDataWord {
  word: string
  start_ts: number
  end_ts: number
  chunkStartTs: number
  chunkEndTs: number
  chunkIdx: number
  pageIndex: number
  isAligned: boolean
  wordIdx: number
}

export interface MarkdownActiveMetaDataPage {
  words: MarkdownActiveMetaDataWord[]
  pageIndex: number
}

export type MarkdownActiveMetaDataResponseViewMode =
  (typeof MarkdownActiveMetaDataResponseViewMode)[keyof typeof MarkdownActiveMetaDataResponseViewMode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarkdownActiveMetaDataResponseViewMode = {
  MARKDOWN: "MARKDOWN",
} as const

export interface MarkdownActiveMetaDataResponse {
  viewMode: MarkdownActiveMetaDataResponseViewMode
  prevPageWords: MarkdownActiveMetaDataPage
  currentPageWords: MarkdownActiveMetaDataPage
  nextPageWords: MarkdownActiveMetaDataPage
}

export interface DebugConvertTiersDto {
  base64: string
  extension: string
}

export type NewCheckoutSessionDtoReqPeriod =
  (typeof NewCheckoutSessionDtoReqPeriod)[keyof typeof NewCheckoutSessionDtoReqPeriod]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NewCheckoutSessionDtoReqPeriod = {
  MONTH: "MONTH",
  YEAR: "YEAR",
} as const

export interface NewCheckoutSessionDtoReq {
  period: NewCheckoutSessionDtoReqPeriod
  /** Chrome extension awaiting checkout completion */
  extensionId?: string
}

export interface NewCheckoutSessionDtoRes {
  url: string
  /** Free trial days of this checkout (0 = charged right away) */
  trialDays: number
}

export interface TrialEligibilityDtoRes {
  /** Free trial days a new checkout would get */
  trialDays: number
}

export interface ManageSubscriptionDtoRes {
  url: string
}

export interface Buffer {
  [key: string]: unknown
}

export interface EditPromptDto {
  id: string
  prompt: string
}

export interface CreatePromoCodeDto {
  code: string
  premiumDays: number
  /** How many accounts may use it */
  maxUses?: number
  /** ISO date after which it stops working */
  expiresAt?: string
}

export interface DeletePromoCodeDto {
  code: string
}

export interface BannerDto {
  title: string
  text: string
}

/**
 * @nullable
 */
export type GetBannerResponseDtoBanner = BannerDto | null

export interface GetBannerResponseDto {
  /** @nullable */
  banner: GetBannerResponseDtoBanner
}

export interface CreateBannerDto {
  title: string
  text: string
}

export interface DoclingDoneDto {
  [key: string]: unknown
}

export interface AudioChunkReadyDto {
  [key: string]: unknown
}

export interface AudioChunkWordsDto {
  [key: string]: unknown
}

export interface KokoroAudioFinishedDto {
  [key: string]: unknown
}

export interface KokoroCancelledDto {
  [key: string]: unknown
}

export interface ChangelogMyPostDtoRes {
  content: string
  id: number
}

export interface ChangelogMarkAsReadDto {
  postId: string
}

export type ChangelogCreatePostDtoTarget =
  (typeof ChangelogCreatePostDtoTarget)[keyof typeof ChangelogCreatePostDtoTarget]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangelogCreatePostDtoTarget = {
  MOBILE: "MOBILE",
  WEB: "WEB",
  BOTH: "BOTH",
} as const

export interface ChangelogCreatePostDto {
  content: string
  target: ChangelogCreatePostDtoTarget
}

export interface BootstrapProcessingDto {
  shouldReconnectSocket: boolean
}

export interface BootstrapSessionDto {
  version: number
  translationVersion: number
  isGuest: boolean
  accessToken: string
  options: GetMyOptionsDtoRes
  changelog: ChangelogMyPostDtoRes
  processing: BootstrapProcessingDto
}

export type AuthControllerAuthorizeExtensionParams = {
  redirect_uri: string
  state: string
  code_challenge: string
}

export type ContentControllerGetLibraryContentByPageParams = {
  page?: string
  platform?: string
  creationMode?: ContentControllerGetLibraryContentByPageCreationMode
}

export type ContentControllerGetLibraryContentByPageCreationMode =
  (typeof ContentControllerGetLibraryContentByPageCreationMode)[keyof typeof ContentControllerGetLibraryContentByPageCreationMode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContentControllerGetLibraryContentByPageCreationMode = {
  TEXT: "TEXT",
  FILE: "FILE",
  LINK: "LINK",
  CAMERA: "CAMERA",
  SELECTION: "SELECTION",
} as const

export type ContentControllerGetLibraryArchivedContentByPageParams = {
  page?: string
  platform?: string
  creationMode?: ContentControllerGetLibraryArchivedContentByPageCreationMode
}

export type ContentControllerGetLibraryArchivedContentByPageCreationMode =
  (typeof ContentControllerGetLibraryArchivedContentByPageCreationMode)[keyof typeof ContentControllerGetLibraryArchivedContentByPageCreationMode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContentControllerGetLibraryArchivedContentByPageCreationMode = {
  TEXT: "TEXT",
  FILE: "FILE",
  LINK: "LINK",
  CAMERA: "CAMERA",
  SELECTION: "SELECTION",
} as const

export type ContentControllerGetContentMetaDataByActivePageParams = {
  pageIndex: string
}

export type ContentControllerGetContentMetaDataByActivePage200 =
  | PdfActiveMetaDataResponse
  | MarkdownActiveMetaDataResponse

export type ServicePromptsControllerGetUsersCsvParams = {
  plan: string
}

export type ChangelogControllerGetMyPostParams = {
  platform?: ChangelogControllerGetMyPostPlatform
}

export type ChangelogControllerGetMyPostPlatform =
  (typeof ChangelogControllerGetMyPostPlatform)[keyof typeof ChangelogControllerGetMyPostPlatform]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangelogControllerGetMyPostPlatform = {
  MOBILE: "MOBILE",
  WEB: "WEB",
} as const

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

export const infrastructureControllerCheckInfrastructure = (
  options?: SecondParameter<typeof createInstance<InfrastructureRes>>
) => {
  return createInstance<InfrastructureRes>(
    { url: `/api/infrastructure`, method: "GET" },
    options
  )
}

export const infrastructureControllerGetTestersList = (
  options?: SecondParameter<typeof createInstance<string[]>>
) => {
  return createInstance<string[]>(
    { url: `/api/infrastructure/testers`, method: "GET" },
    options
  )
}

export const authControllerCreateGuest = (
  guestAuthDto: BodyType<GuestAuthDto>,
  options?: SecondParameter<typeof createInstance<AccessTokenResponse>>
) => {
  return createInstance<AccessTokenResponse>(
    {
      url: `/api/auth/guest`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: guestAuthDto,
    },
    options
  )
}

export const authControllerUpgradeGuest = (
  guestUpgradeDto: BodyType<GuestUpgradeDto>,
  options?: SecondParameter<typeof createInstance<PendingGuestUpgradeDto>>
) => {
  return createInstance<PendingGuestUpgradeDto>(
    {
      url: `/api/auth/guest/upgrade`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: guestUpgradeDto,
    },
    options
  )
}

export const authControllerGetPendingGuestUpgrade = (
  options?: SecondParameter<typeof createInstance<PendingGuestUpgradeDto>>
) => {
  return createInstance<PendingGuestUpgradeDto>(
    { url: `/api/auth/guest/upgrade`, method: "GET" },
    options
  )
}

export const authControllerCancelPendingGuestUpgrade = (
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    { url: `/api/auth/guest/upgrade`, method: "DELETE" },
    options
  )
}

export const authControllerResendPendingGuestUpgrade = (
  options?: SecondParameter<typeof createInstance<PendingGuestUpgradeDto>>
) => {
  return createInstance<PendingGuestUpgradeDto>(
    { url: `/api/auth/guest/upgrade/resend`, method: "POST" },
    options
  )
}

export const authControllerConfirmPendingGuestUpgrade = (
  emailConfirmDtoReq: BodyType<EmailConfirmDtoReq>,
  options?: SecondParameter<typeof createInstance<AccessTokenResponse>>
) => {
  return createInstance<AccessTokenResponse>(
    {
      url: `/api/auth/guest/upgrade/confirm`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: emailConfirmDtoReq,
    },
    options
  )
}

export const authControllerSignUp = (
  signUpDtoReq: BodyType<SignUpDtoReq>,
  options?: SecondParameter<typeof createInstance<AccessTokenResponse>>
) => {
  return createInstance<AccessTokenResponse>(
    {
      url: `/api/auth/sign-up`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: signUpDtoReq,
    },
    options
  )
}

export const authControllerSignIn = (
  authDtoReq: BodyType<AuthDtoReq>,
  options?: SecondParameter<typeof createInstance<AccessTokenResponse>>
) => {
  return createInstance<AccessTokenResponse>(
    {
      url: `/api/auth/sign-in`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authDtoReq,
    },
    options
  )
}

export const authControllerUpdateMyToken = (
  options?: SecondParameter<typeof createInstance<AccessTokenResponse>>
) => {
  return createInstance<AccessTokenResponse>(
    { url: `/api/auth/update-token`, method: "GET" },
    options
  )
}

export const authControllerRefresh = (
  refreshSessionDto: BodyType<RefreshSessionDto>,
  options?: SecondParameter<typeof createInstance<SessionTokensDto>>
) => {
  return createInstance<SessionTokensDto>(
    {
      url: `/api/auth/refresh`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: refreshSessionDto,
    },
    options
  )
}

export const authControllerAuthorizeExtension = (
  params: AuthControllerAuthorizeExtensionParams,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    { url: `/api/auth/extension/authorize`, method: "GET", params },
    options
  )
}

export const authControllerAuthorizeExtensionWithAccessToken = (
  authorizeExtensionDto: BodyType<AuthorizeExtensionDto>,
  options?: SecondParameter<
    typeof createInstance<AuthorizeExtensionResponseDto>
  >
) => {
  return createInstance<AuthorizeExtensionResponseDto>(
    {
      url: `/api/auth/extension/authorize`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authorizeExtensionDto,
    },
    options
  )
}

export const authControllerExchangeExtensionCode = (
  exchangeExtensionCodeDto: BodyType<ExchangeExtensionCodeDto>,
  options?: SecondParameter<typeof createInstance<SessionTokensDto>>
) => {
  return createInstance<SessionTokensDto>(
    {
      url: `/api/auth/extension/exchange`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: exchangeExtensionCodeDto,
    },
    options
  )
}

export const authControllerLogout = (
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    { url: `/api/auth/logout`, method: "POST" },
    options
  )
}

export const authControllerLogoutCookie = (
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    { url: `/api/auth/logout-cookie`, method: "POST" },
    options
  )
}

export const authControllerGetSessions = (
  options?: SecondParameter<typeof createInstance<AuthSessionDto[]>>
) => {
  return createInstance<AuthSessionDto[]>(
    { url: `/api/auth/sessions`, method: "GET" },
    options
  )
}

export const authControllerRevokeOtherSessions = (
  options?: SecondParameter<typeof createInstance<RevokeSessionsResponseDto>>
) => {
  return createInstance<RevokeSessionsResponseDto>(
    { url: `/api/auth/sessions/revoke-others`, method: "POST" },
    options
  )
}

export const authControllerRevokeSession = (
  sessionId: string,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    { url: `/api/auth/sessions/${sessionId}/revoke`, method: "POST" },
    options
  )
}

export const authControllerResetPasswordRequest = (
  resetPasswordDtoReq: BodyType<ResetPasswordDtoReq>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/auth/reset-password-request`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: resetPasswordDtoReq,
    },
    options
  )
}

export const authControllerValidateResetPasswordCode = (
  code: string,
  options?: SecondParameter<typeof createInstance<ValidateResetPasswordCodeRes>>
) => {
  return createInstance<ValidateResetPasswordCodeRes>(
    { url: `/api/auth/reset-password/${code}`, method: "GET" },
    options
  )
}

export const authControllerProcessResetPass = (
  processResetPasswordDtoReq: BodyType<ProcessResetPasswordDtoReq>,
  options?: SecondParameter<typeof createInstance<AccessTokenResponse>>
) => {
  return createInstance<AccessTokenResponse>(
    {
      url: `/api/auth/reset-password`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: processResetPasswordDtoReq,
    },
    options
  )
}

export const authControllerEmailConfirm = (
  emailConfirmDtoReq: BodyType<EmailConfirmDtoReq>,
  options?: SecondParameter<typeof createInstance<AccessTokenResponse>>
) => {
  return createInstance<AccessTokenResponse>(
    {
      url: `/api/auth/email-confirm`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: emailConfirmDtoReq,
    },
    options
  )
}

export const authControllerUpdateUserEmail = (
  updateEmailDtoReq: BodyType<UpdateEmailDtoReq>,
  options?: SecondParameter<typeof createInstance<UpdateEmailDtoRes>>
) => {
  return createInstance<UpdateEmailDtoRes>(
    {
      url: `/api/auth/update-email`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: updateEmailDtoReq,
    },
    options
  )
}

export const authControllerSocialAuth = (
  socialAuthDto: BodyType<SocialAuthDto>,
  options?: SecondParameter<typeof createInstance<OuathAccessTokenResponse>>
) => {
  return createInstance<OuathAccessTokenResponse>(
    {
      url: `/api/auth/oauth`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: socialAuthDto,
    },
    options
  )
}

export const authControllerApplyPromoCode = (
  applyPromoCodeDto: BodyType<ApplyPromoCodeDto>,
  options?: SecondParameter<typeof createInstance<AccessTokenResponse>>
) => {
  return createInstance<AccessTokenResponse>(
    {
      url: `/api/auth/apply-promo-code`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: applyPromoCodeDto,
    },
    options
  )
}

export const authControllerHasCode = (
  options?: SecondParameter<typeof createInstance<StillHaveEmailNumbersRes>>
) => {
  return createInstance<StillHaveEmailNumbersRes>(
    { url: `/api/auth/has-code`, method: "GET" },
    options
  )
}

export const authControllerResendEmailCode = (
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    { url: `/api/auth/resend-email-code`, method: "POST" },
    options
  )
}

export const authControllerChangeMyPassword = (
  changePasswordDtoReq: BodyType<ChangePasswordDtoReq>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/auth/change-password`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: changePasswordDtoReq,
    },
    options
  )
}

export const translationControllerNewTranslation = (
  newTranslationDtoReq: BodyType<NewTranslationDtoReq>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/translation/new`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: newTranslationDtoReq,
    },
    options
  )
}

export const translationControllerGetDictionary = (
  lang: string,
  options?: SecondParameter<typeof createInstance<TranslationDictionaryDto>>
) => {
  return createInstance<TranslationDictionaryDto>(
    { url: `/api/translation/dictionary/${lang}`, method: "GET" },
    options
  )
}

export const translationControllerGetVersion = (
  options?: SecondParameter<typeof createInstance<TranslationVersionDto>>
) => {
  return createInstance<TranslationVersionDto>(
    { url: `/api/translation/version`, method: "GET" },
    options
  )
}

export const translationControllerGetLangsList = (
  options?: SecondParameter<typeof createInstance<LangListItem[]>>
) => {
  return createInstance<LangListItem[]>(
    { url: `/api/translation/lang-list`, method: "GET" },
    options
  )
}

export const userControllerDeleteMe = (
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>({ url: `/api/user`, method: "DELETE" }, options)
}

export const userControllerStartChangeEmail = (
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    { url: `/api/user/start-change-email`, method: "POST" },
    options
  )
}

export const userControllerProvideStartChangeEmailCode = (
  provideCodeDtoReq: BodyType<ProvideCodeDtoReq>,
  options?: SecondParameter<typeof createInstance<ProvideCodeDtoRes>>
) => {
  return createInstance<ProvideCodeDtoRes>(
    {
      url: `/api/user/provide-change-email-start-code`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: provideCodeDtoReq,
    },
    options
  )
}

export const userControllerProvideNewEmail = (
  provideNewEmailDtoReq: BodyType<ProvideNewEmailDtoReq>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/user/provide-new-email`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: provideNewEmailDtoReq,
    },
    options
  )
}

export const userControllerGetMyOptions = (
  options?: SecondParameter<typeof createInstance<GetMyOptionsDtoRes>>
) => {
  return createInstance<GetMyOptionsDtoRes>(
    { url: `/api/user/options`, method: "GET" },
    options
  )
}

export const userControllerSetMyOptions = (
  setMyOptionsDtoReq: BodyType<SetMyOptionsDtoReq>,
  options?: SecondParameter<typeof createInstance<GetMyOptionsDtoRes>>
) => {
  return createInstance<GetMyOptionsDtoRes>(
    {
      url: `/api/user/options`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setMyOptionsDtoReq,
    },
    options
  )
}

export const userControllerLeaveFeedback = (
  leaveFeedbackDtoReq: BodyType<LeaveFeedbackDtoReq>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/user/feedback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: leaveFeedbackDtoReq,
    },
    options
  )
}

export const userControllerMoveLaterFeedbackTime = (
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    { url: `/api/user/move-later-feedback-time`, method: "POST" },
    options
  )
}

export const userControllerRequestNativeFeedback = (
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    { url: `/api/user/requested-native-feedback`, method: "POST" },
    options
  )
}

export const contentControllerGetMyContent = (
  options?: SecondParameter<typeof createInstance<ContentItem[]>>
) => {
  return createInstance<ContentItem[]>(
    { url: `/api/content/my`, method: "GET" },
    options
  )
}

export const contentControllerGetLibraryContentByPage = (
  params?: ContentControllerGetLibraryContentByPageParams,
  options?: SecondParameter<typeof createInstance<GetLibraryContentDtoRes>>
) => {
  return createInstance<GetLibraryContentDtoRes>(
    { url: `/api/content/library`, method: "GET", params },
    options
  )
}

export const contentControllerGetLibraryArchivedContentByPage = (
  params?: ContentControllerGetLibraryArchivedContentByPageParams,
  options?: SecondParameter<
    typeof createInstance<GetLibraryArchivedContentDtoRes>
  >
) => {
  return createInstance<GetLibraryArchivedContentDtoRes>(
    { url: `/api/content/archived`, method: "GET", params },
    options
  )
}

export const contentControllerChangeArchivedStatus = (
  setArchivedDto: BodyType<SetArchivedDto>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/content/archived`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: setArchivedDto,
    },
    options
  )
}

export const contentControllerGetLibraryTempContent = (
  options?: SecondParameter<typeof createInstance<TempContentItem[]>>
) => {
  return createInstance<TempContentItem[]>(
    { url: `/api/content/temp-content`, method: "GET" },
    options
  )
}

export const contentControllerGetItemById = (
  id: string,
  options?: SecondParameter<typeof createInstance<ContentItem>>
) => {
  return createInstance<ContentItem>(
    { url: `/api/content/item/${id}`, method: "GET" },
    options
  )
}

export const contentControllerShouldIReconnectToProcessSocket = (
  options?: SecondParameter<typeof createInstance<boolean>>
) => {
  return createInstance<boolean>(
    { url: `/api/content/should-i-reconnect-to-process-socket`, method: "GET" },
    options
  )
}

export const contentControllerInitContentUpload = (
  initContentUploadDto: BodyType<InitContentUploadDto>,
  options?: SecondParameter<typeof createInstance<InitContentUploadResponseDto>>
) => {
  return createInstance<InitContentUploadResponseDto>(
    {
      url: `/api/content/upload/init`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: initContentUploadDto,
    },
    options
  )
}

export const contentControllerStartContentUpload = (
  uploadId: string,
  startContentUploadDto: BodyType<StartContentUploadDto>,
  options?: SecondParameter<
    typeof createInstance<StartContentCreationResponseDto>
  >
) => {
  return createInstance<StartContentCreationResponseDto>(
    {
      url: `/api/content/upload/${uploadId}/start`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: startContentUploadDto,
    },
    options
  )
}

export const contentControllerCreateContentFromTextHttp = (
  createContentFromTextHttpDto: BodyType<CreateContentFromTextHttpDto>,
  options?: SecondParameter<
    typeof createInstance<StartContentCreationResponseDto>
  >
) => {
  return createInstance<StartContentCreationResponseDto>(
    {
      url: `/api/content/create-from-text`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createContentFromTextHttpDto,
    },
    options
  )
}

export const contentControllerDtoPurpose = (
  options?: SecondParameter<typeof createInstance<ContentCreatedDto>>
) => {
  return createInstance<ContentCreatedDto>(
    { url: `/api/content/some-one`, method: "GET" },
    options
  )
}

export const contentControllerDtoPurposeTwo = (
  contentFromTextDto: BodyType<ContentFromTextDto>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/content/some-two`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: contentFromTextDto,
    },
    options
  )
}

export const contentControllerDtoPurposeThree = (
  contentFromUrlDto: BodyType<ContentFromUrlDto>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/content/some-three`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: contentFromUrlDto,
    },
    options
  )
}

export const contentControllerChangeTitle = (
  changeTitleDto: BodyType<ChangeTitleDto>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/content/title`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: changeTitleDto,
    },
    options
  )
}

export const contentControllerDeleteItem = (
  contentIdDto: BodyType<ContentIdDto>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/content/item`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: contentIdDto,
    },
    options
  )
}

export const contentControllerCancelTask = (
  removeTaskDto: BodyType<RemoveTaskDto>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/content/cancel-task`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: removeTaskDto,
    },
    options
  )
}

export const contentControllerGetManifestForProcessingContent = (
  contentId: string,
  options?: SecondParameter<
    typeof createInstance<GetManifestForProcessingContentDtoRes>
  >
) => {
  return createInstance<GetManifestForProcessingContentDtoRes>(
    {
      url: `/api/content/get-manifest-for-processing-content/${contentId}`,
      method: "GET",
    },
    options
  )
}

export const contentControllerGetChunkWords = (
  id: string,
  chunkIdx: string,
  options?: SecondParameter<typeof createInstance<ChunkWordsDto>>
) => {
  return createInstance<ChunkWordsDto>(
    { url: `/api/content/item/${id}/chunk-words/${chunkIdx}`, method: "GET" },
    options
  )
}

export const contentControllerGetContentSource = (
  id: string,
  options?: SecondParameter<typeof createInstance<ContentSourceDto>>
) => {
  return createInstance<ContentSourceDto>(
    { url: `/api/content/item/${id}/source`, method: "GET" },
    options
  )
}

export const contentControllerGetContentMetaDataByActivePage = (
  contentId: string,
  params: ContentControllerGetContentMetaDataByActivePageParams,
  options?: SecondParameter<
    typeof createInstance<ContentControllerGetContentMetaDataByActivePage200>
  >
) => {
  return createInstance<ContentControllerGetContentMetaDataByActivePage200>(
    {
      url: `/api/content/get-content-meta-data-by-active-page/${contentId}`,
      method: "GET",
      params,
    },
    options
  )
}

export const contentControllerDebugConvertTiers = (
  debugConvertTiersDto: BodyType<DebugConvertTiersDto>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/content/debug-convert-tiers`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: debugConvertTiersDto,
    },
    options
  )
}

export const paymentControllerRevenueCat = (
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    { url: `/api/payment/revenue-cat`, method: "POST" },
    options
  )
}

export const stripeControllerNewCheckout = (
  newCheckoutSessionDtoReq: BodyType<NewCheckoutSessionDtoReq>,
  options?: SecondParameter<typeof createInstance<NewCheckoutSessionDtoRes>>
) => {
  return createInstance<NewCheckoutSessionDtoRes>(
    {
      url: `/api/stripe/checkout`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: newCheckoutSessionDtoReq,
    },
    options
  )
}

export const stripeControllerTrialEligibility = (
  options?: SecondParameter<typeof createInstance<TrialEligibilityDtoRes>>
) => {
  return createInstance<TrialEligibilityDtoRes>(
    { url: `/api/stripe/trial-eligibility`, method: "GET" },
    options
  )
}

export const stripeControllerSuccessCallbackRedirect = (
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    { url: `/api/stripe/success`, method: "GET" },
    options
  )
}

export const stripeControllerBillingPortal = (
  options?: SecondParameter<typeof createInstance<ManageSubscriptionDtoRes>>
) => {
  return createInstance<ManageSubscriptionDtoRes>(
    { url: `/api/stripe/billing-portal`, method: "GET" },
    options
  )
}

export const webhookStripeControllerSubscribtionRenewalHook = (
  buffer: BodyType<Buffer>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/webhook-stripe/renewal`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: buffer,
    },
    options
  )
}

export const servicePromptsControllerEditPrompt = (
  editPromptDto: BodyType<EditPromptDto>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/service-prompts`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: editPromptDto,
    },
    options
  )
}

export const servicePromptsControllerGetPrompt = (
  id: string,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    { url: `/api/service-prompts/get/${id}`, method: "GET" },
    options
  )
}

export const servicePromptsControllerGetUsersCsv = (
  params: ServicePromptsControllerGetUsersCsvParams,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    { url: `/api/service-prompts/get-users-csv`, method: "GET", params },
    options
  )
}

export const promoCreationControllerGetList = (
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    { url: `/api/promo-creation/read`, method: "GET" },
    options
  )
}

export const promoCreationControllerCreate = (
  createPromoCodeDto: BodyType<CreatePromoCodeDto>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/promo-creation/create`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createPromoCodeDto,
    },
    options
  )
}

export const promoCreationControllerDelete = (
  deletePromoCodeDto: BodyType<DeletePromoCodeDto>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/promo-creation/delete`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: deletePromoCodeDto,
    },
    options
  )
}

export const bannerControllerGetBanner = (
  options?: SecondParameter<typeof createInstance<GetBannerResponseDto>>
) => {
  return createInstance<GetBannerResponseDto>(
    { url: `/api/banner`, method: "GET" },
    options
  )
}

export const bannerControllerCreate = (
  createBannerDto: BodyType<CreateBannerDto>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/banner`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createBannerDto,
    },
    options
  )
}

export const bannerControllerDelete = (
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>({ url: `/api/banner`, method: "DELETE" }, options)
}

export const changelogControllerGetMyPost = (
  params?: ChangelogControllerGetMyPostParams,
  options?: SecondParameter<typeof createInstance<ChangelogMyPostDtoRes>>
) => {
  return createInstance<ChangelogMyPostDtoRes>(
    { url: `/api/changelog/my`, method: "GET", params },
    options
  )
}

export const changelogControllerMarkPostAsRead = (
  changelogMarkAsReadDto: BodyType<ChangelogMarkAsReadDto>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/changelog/mark-as-read`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changelogMarkAsReadDto,
    },
    options
  )
}

export const adminControllerCreatePost = (
  changelogCreatePostDto: BodyType<ChangelogCreatePostDto>,
  options?: SecondParameter<typeof createInstance<void>>
) => {
  return createInstance<void>(
    {
      url: `/api/changelog/admin/create-post`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changelogCreatePostDto,
    },
    options
  )
}

export const bootstrapControllerGetSession = (
  options?: SecondParameter<typeof createInstance<BootstrapSessionDto>>
) => {
  return createInstance<BootstrapSessionDto>(
    { url: `/api/bootstrap/session`, method: "GET" },
    options
  )
}

export type InfrastructureControllerCheckInfrastructureResult = NonNullable<
  Awaited<ReturnType<typeof infrastructureControllerCheckInfrastructure>>
>
export type InfrastructureControllerGetTestersListResult = NonNullable<
  Awaited<ReturnType<typeof infrastructureControllerGetTestersList>>
>
export type AuthControllerCreateGuestResult = NonNullable<
  Awaited<ReturnType<typeof authControllerCreateGuest>>
>
export type AuthControllerUpgradeGuestResult = NonNullable<
  Awaited<ReturnType<typeof authControllerUpgradeGuest>>
>
export type AuthControllerGetPendingGuestUpgradeResult = NonNullable<
  Awaited<ReturnType<typeof authControllerGetPendingGuestUpgrade>>
>
export type AuthControllerCancelPendingGuestUpgradeResult = NonNullable<
  Awaited<ReturnType<typeof authControllerCancelPendingGuestUpgrade>>
>
export type AuthControllerResendPendingGuestUpgradeResult = NonNullable<
  Awaited<ReturnType<typeof authControllerResendPendingGuestUpgrade>>
>
export type AuthControllerConfirmPendingGuestUpgradeResult = NonNullable<
  Awaited<ReturnType<typeof authControllerConfirmPendingGuestUpgrade>>
>
export type AuthControllerSignUpResult = NonNullable<
  Awaited<ReturnType<typeof authControllerSignUp>>
>
export type AuthControllerSignInResult = NonNullable<
  Awaited<ReturnType<typeof authControllerSignIn>>
>
export type AuthControllerUpdateMyTokenResult = NonNullable<
  Awaited<ReturnType<typeof authControllerUpdateMyToken>>
>
export type AuthControllerRefreshResult = NonNullable<
  Awaited<ReturnType<typeof authControllerRefresh>>
>
export type AuthControllerAuthorizeExtensionResult = NonNullable<
  Awaited<ReturnType<typeof authControllerAuthorizeExtension>>
>
export type AuthControllerAuthorizeExtensionWithAccessTokenResult = NonNullable<
  Awaited<ReturnType<typeof authControllerAuthorizeExtensionWithAccessToken>>
>
export type AuthControllerExchangeExtensionCodeResult = NonNullable<
  Awaited<ReturnType<typeof authControllerExchangeExtensionCode>>
>
export type AuthControllerLogoutResult = NonNullable<
  Awaited<ReturnType<typeof authControllerLogout>>
>
export type AuthControllerLogoutCookieResult = NonNullable<
  Awaited<ReturnType<typeof authControllerLogoutCookie>>
>
export type AuthControllerGetSessionsResult = NonNullable<
  Awaited<ReturnType<typeof authControllerGetSessions>>
>
export type AuthControllerRevokeOtherSessionsResult = NonNullable<
  Awaited<ReturnType<typeof authControllerRevokeOtherSessions>>
>
export type AuthControllerRevokeSessionResult = NonNullable<
  Awaited<ReturnType<typeof authControllerRevokeSession>>
>
export type AuthControllerResetPasswordRequestResult = NonNullable<
  Awaited<ReturnType<typeof authControllerResetPasswordRequest>>
>
export type AuthControllerValidateResetPasswordCodeResult = NonNullable<
  Awaited<ReturnType<typeof authControllerValidateResetPasswordCode>>
>
export type AuthControllerProcessResetPassResult = NonNullable<
  Awaited<ReturnType<typeof authControllerProcessResetPass>>
>
export type AuthControllerEmailConfirmResult = NonNullable<
  Awaited<ReturnType<typeof authControllerEmailConfirm>>
>
export type AuthControllerUpdateUserEmailResult = NonNullable<
  Awaited<ReturnType<typeof authControllerUpdateUserEmail>>
>
export type AuthControllerSocialAuthResult = NonNullable<
  Awaited<ReturnType<typeof authControllerSocialAuth>>
>
export type AuthControllerApplyPromoCodeResult = NonNullable<
  Awaited<ReturnType<typeof authControllerApplyPromoCode>>
>
export type AuthControllerHasCodeResult = NonNullable<
  Awaited<ReturnType<typeof authControllerHasCode>>
>
export type AuthControllerResendEmailCodeResult = NonNullable<
  Awaited<ReturnType<typeof authControllerResendEmailCode>>
>
export type AuthControllerChangeMyPasswordResult = NonNullable<
  Awaited<ReturnType<typeof authControllerChangeMyPassword>>
>
export type TranslationControllerNewTranslationResult = NonNullable<
  Awaited<ReturnType<typeof translationControllerNewTranslation>>
>
export type TranslationControllerGetDictionaryResult = NonNullable<
  Awaited<ReturnType<typeof translationControllerGetDictionary>>
>
export type TranslationControllerGetVersionResult = NonNullable<
  Awaited<ReturnType<typeof translationControllerGetVersion>>
>
export type TranslationControllerGetLangsListResult = NonNullable<
  Awaited<ReturnType<typeof translationControllerGetLangsList>>
>
export type UserControllerDeleteMeResult = NonNullable<
  Awaited<ReturnType<typeof userControllerDeleteMe>>
>
export type UserControllerStartChangeEmailResult = NonNullable<
  Awaited<ReturnType<typeof userControllerStartChangeEmail>>
>
export type UserControllerProvideStartChangeEmailCodeResult = NonNullable<
  Awaited<ReturnType<typeof userControllerProvideStartChangeEmailCode>>
>
export type UserControllerProvideNewEmailResult = NonNullable<
  Awaited<ReturnType<typeof userControllerProvideNewEmail>>
>
export type UserControllerGetMyOptionsResult = NonNullable<
  Awaited<ReturnType<typeof userControllerGetMyOptions>>
>
export type UserControllerSetMyOptionsResult = NonNullable<
  Awaited<ReturnType<typeof userControllerSetMyOptions>>
>
export type UserControllerLeaveFeedbackResult = NonNullable<
  Awaited<ReturnType<typeof userControllerLeaveFeedback>>
>
export type UserControllerMoveLaterFeedbackTimeResult = NonNullable<
  Awaited<ReturnType<typeof userControllerMoveLaterFeedbackTime>>
>
export type UserControllerRequestNativeFeedbackResult = NonNullable<
  Awaited<ReturnType<typeof userControllerRequestNativeFeedback>>
>
export type ContentControllerGetMyContentResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerGetMyContent>>
>
export type ContentControllerGetLibraryContentByPageResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerGetLibraryContentByPage>>
>
export type ContentControllerGetLibraryArchivedContentByPageResult =
  NonNullable<
    Awaited<ReturnType<typeof contentControllerGetLibraryArchivedContentByPage>>
  >
export type ContentControllerChangeArchivedStatusResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerChangeArchivedStatus>>
>
export type ContentControllerGetLibraryTempContentResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerGetLibraryTempContent>>
>
export type ContentControllerGetItemByIdResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerGetItemById>>
>
export type ContentControllerShouldIReconnectToProcessSocketResult =
  NonNullable<
    Awaited<ReturnType<typeof contentControllerShouldIReconnectToProcessSocket>>
  >
export type ContentControllerInitContentUploadResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerInitContentUpload>>
>
export type ContentControllerStartContentUploadResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerStartContentUpload>>
>
export type ContentControllerCreateContentFromTextHttpResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerCreateContentFromTextHttp>>
>
export type ContentControllerDtoPurposeResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerDtoPurpose>>
>
export type ContentControllerDtoPurposeTwoResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerDtoPurposeTwo>>
>
export type ContentControllerDtoPurposeThreeResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerDtoPurposeThree>>
>
export type ContentControllerChangeTitleResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerChangeTitle>>
>
export type ContentControllerDeleteItemResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerDeleteItem>>
>
export type ContentControllerCancelTaskResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerCancelTask>>
>
export type ContentControllerGetManifestForProcessingContentResult =
  NonNullable<
    Awaited<ReturnType<typeof contentControllerGetManifestForProcessingContent>>
  >
export type ContentControllerGetChunkWordsResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerGetChunkWords>>
>
export type ContentControllerGetContentSourceResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerGetContentSource>>
>
export type ContentControllerGetContentMetaDataByActivePageResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerGetContentMetaDataByActivePage>>
>
export type ContentControllerDebugConvertTiersResult = NonNullable<
  Awaited<ReturnType<typeof contentControllerDebugConvertTiers>>
>
export type PaymentControllerRevenueCatResult = NonNullable<
  Awaited<ReturnType<typeof paymentControllerRevenueCat>>
>
export type StripeControllerNewCheckoutResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerNewCheckout>>
>
export type StripeControllerTrialEligibilityResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerTrialEligibility>>
>
export type StripeControllerSuccessCallbackRedirectResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerSuccessCallbackRedirect>>
>
export type StripeControllerBillingPortalResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerBillingPortal>>
>
export type WebhookStripeControllerSubscribtionRenewalHookResult = NonNullable<
  Awaited<ReturnType<typeof webhookStripeControllerSubscribtionRenewalHook>>
>
export type ServicePromptsControllerEditPromptResult = NonNullable<
  Awaited<ReturnType<typeof servicePromptsControllerEditPrompt>>
>
export type ServicePromptsControllerGetPromptResult = NonNullable<
  Awaited<ReturnType<typeof servicePromptsControllerGetPrompt>>
>
export type ServicePromptsControllerGetUsersCsvResult = NonNullable<
  Awaited<ReturnType<typeof servicePromptsControllerGetUsersCsv>>
>
export type PromoCreationControllerGetListResult = NonNullable<
  Awaited<ReturnType<typeof promoCreationControllerGetList>>
>
export type PromoCreationControllerCreateResult = NonNullable<
  Awaited<ReturnType<typeof promoCreationControllerCreate>>
>
export type PromoCreationControllerDeleteResult = NonNullable<
  Awaited<ReturnType<typeof promoCreationControllerDelete>>
>
export type BannerControllerGetBannerResult = NonNullable<
  Awaited<ReturnType<typeof bannerControllerGetBanner>>
>
export type BannerControllerCreateResult = NonNullable<
  Awaited<ReturnType<typeof bannerControllerCreate>>
>
export type BannerControllerDeleteResult = NonNullable<
  Awaited<ReturnType<typeof bannerControllerDelete>>
>
export type ChangelogControllerGetMyPostResult = NonNullable<
  Awaited<ReturnType<typeof changelogControllerGetMyPost>>
>
export type ChangelogControllerMarkPostAsReadResult = NonNullable<
  Awaited<ReturnType<typeof changelogControllerMarkPostAsRead>>
>
export type AdminControllerCreatePostResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerCreatePost>>
>
export type BootstrapControllerGetSessionResult = NonNullable<
  Awaited<ReturnType<typeof bootstrapControllerGetSession>>
>
